/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantDiscoveryResponse = {
  login_url: string | null;
  post_discovery_flow: TenantDiscoveryResponse.post_discovery_flow;
};
export namespace TenantDiscoveryResponse {
  export enum post_discovery_flow {
    SAML = 'saml',
    PASSWORD = 'password',
  }
}

